import { render, staticRenderFns } from "./ArticleGrid.vue?vue&type=template&id=9ab52c30&scoped=true"
import script from "./ArticleGrid.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticleGrid.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ArticleGrid.vue?vue&type=style&index=0&id=9ab52c30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab52c30",
  null
  
)

export default component.exports